import { motion } from "framer-motion";

import { LOGO_PATHS } from "../model/constants";

type SmileSimulationLogoProps = {
  className?: string;
  animatePaths?: boolean;
  animateEntry?: boolean;
  float?: boolean;
};

export function SmileSimulationLogo({
  className,
  animatePaths = false,
  animateEntry = false,
  float = false,
}: SmileSimulationLogoProps) {
  const content = animateEntry ? (
    <motion.svg
      width="180"
      height="46"
      viewBox="0 0 180 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      initial={{ opacity: 0, scale: 0.94 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        opacity: { duration: 0.45, ease: "easeOut" },
        scale: { duration: 0.7, ease: [0.22, 1, 0.36, 1] },
      }}
      aria-hidden="true"
    >
      {LOGO_PATHS.map((path, index) =>
        animatePaths ? (
          <motion.path
            key={`${index}-${path.fill}`}
            d={path.d}
            fill={path.fill}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              duration: 0.55,
              delay: 0.18 + index * 0.05,
              ease: [0.22, 1, 0.36, 1],
            }}
          />
        ) : (
          <path key={`${index}-${path.fill}`} d={path.d} fill={path.fill} />
        ),
      )}
    </motion.svg>
  ) : (
    <svg
      width="180"
      height="46"
      viewBox="0 0 180 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      {LOGO_PATHS.map((path, index) =>
        animatePaths ? (
          <motion.path
            key={`${index}-${path.fill}`}
            d={path.d}
            fill={path.fill}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              duration: 0.55,
              delay: 0.18 + index * 0.05,
              ease: [0.22, 1, 0.36, 1],
            }}
          />
        ) : (
          <path key={`${index}-${path.fill}`} d={path.d} fill={path.fill} />
        ),
      )}
    </svg>
  );

  if (!float) {
    return content;
  }

  return (
    <motion.div
      animate={{ y: [0, -4, 0] }}
      transition={{ duration: 3.4, repeat: Infinity, ease: "easeInOut" }}
    >
      {content}
    </motion.div>
  );
}
